module.exports = __webpack_public_path__ + "static/media/order-created-sound.b9a067da.mp3";